import HourlyForecast from "./HourlyForecast"

export default HourlyForecast
